import { LockIcon } from './LockIcon';

/**
 * author: Google
 * id D711AFDE-2B8D-4932-82AC-A04E7B2810AE
 * name lock
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock.svg
 * tags
 * - Lock 
 * - Home Automation 
 * - Automotive 
 */
export const HttpsIcon = LockIcon;
export default HttpsIcon